import { Maybe } from "../../../../lib/misc/option";
import { Interval } from "./Domain";
function is_numeric_range(x) {
    return typeof x[0] === 'number' && typeof x[1] === 'number';
}
export class Bucket {
    constructor(name, visible, interval) {
        this.name = name;
        this.visible = visible;
        this.interval = interval;
    }
}
export class BucketContainer {
    constructor(layer_defs) {
        this.buckets = [];
        this.load(layer_defs);
    }
    get_bucket_by_label(label) {
        return Maybe(this.buckets.find(b => b.name === label));
    }
    as_array() {
        return this.buckets;
    }
    load(defs) {
        defs.map(d => this.handle_definition(d));
    }
    date_to_epoch_timestamp(dt) {
        const epoch = new Date(1970, 0);
        return Math.floor((dt.getTime() - epoch.getTime()) / 1000);
    }
    handle_definition(def) {
        var _a, _b;
        if (def.range) {
            const visible = def.visible === null || def.visible === undefined ? true : def.visible;
            if (is_numeric_range(def.range)) {
                this.add_bucket(def.range, def.label, visible);
                return;
            }
            else {
                const timestamps = def.range.map(dtstr => new Date(dtstr)).map(dt => this.date_to_epoch_timestamp(dt));
                this.add_bucket(timestamps, def.label, visible);
                return;
            }
        }
        let internal_nums = (_a = def.label.replace(/,/g, '').match(/\d+/g)) === null || _a === void 0 ? void 0 : _a.map(v => Number(v));
        if ((internal_nums === null || internal_nums === void 0 ? void 0 : internal_nums.length) === 1) {
            if (def.label.endsWith('+'))
                internal_nums.push(Number.POSITIVE_INFINITY);
            else
                internal_nums.unshift(Number.NEGATIVE_INFINITY);
        }
        if (!internal_nums)
            throw new Error(`Invalid layer definition: ${def}`);
        let visible = def.visible === null || def.visible === undefined ? true : def.visible;
        if (internal_nums.every(v => Number(v) >= 1970 && v.toString().length == 4)) {
            try {
                if (internal_nums.length > 1) {
                    let dts = internal_nums.map(n => new Date(n, 0, 1));
                    internal_nums = dts.map(this.date_to_epoch_timestamp);
                }
                else {
                    let idx = def.label.indexOf(internal_nums[0].toString());
                    if (idx === 0) {
                        if (def.label.length === internal_nums[0].toString().length) {
                            let dt1 = new Date(internal_nums[0], 0, 1);
                            let dt2 = new Date(internal_nums[0] + 1, 0, 1);
                            internal_nums = [dt1, dt2].map(this.date_to_epoch_timestamp);
                        }
                        else {
                            let dt = new Date(internal_nums[0], 0, 1);
                            let ts = this.date_to_epoch_timestamp(dt);
                            internal_nums = [ts, Number.POSITIVE_INFINITY];
                        }
                    }
                    else {
                        let dt = new Date(internal_nums[0], 0, 1);
                        let ts = this.date_to_epoch_timestamp(dt);
                        internal_nums = [Number.NEGATIVE_INFINITY, ts];
                    }
                }
            }
            catch (_c) {
                internal_nums = ((_b = def.label.replace(/,/g, '').match(/\d+/g)) !== null && _b !== void 0 ? _b : []).map(v => Number(v));
            }
        }
        this.add_bucket(internal_nums, def.label, visible);
    }
    add_bucket(nums, label, visible) {
        const iv = new Interval(nums[0], nums[1]);
        this.buckets.push(new Bucket(label, visible, iv));
    }
}
